module.exports = __webpack_public_path__ + "img/green-2-mb.1e062543.png";